// extracted by mini-css-extract-plugin
export var bounce = "_nq-1";
export var generatingText = "_nq-6";
export var lightning = "_nq-4";
export var popup = "_nq-5";
export var progressBar = "_nq-7";
export var progressFill = "_nq-8";
export var progressShimmer = "_nq-9";
export var progressText = "_nq-a";
export var shimmer = "_nq-3";
export var uploadIcon = "_nq-0";
export var uploadingText = "_nq-2";